
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/order/search",
      function () {
        return require("private-next-pages/order/search.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/order/search"])
      });
    }
  